import { css } from '@emotion/css';
import { AlignItems, Display, JustifyContent, Spacing } from 'src/styles';

export const center = css`
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
`;

export const addTrustedContactButton = css`
  &.ant-btn {
    ${Spacing.px24}
  }
`;
